module.exports = __webpack_public_path__ + "media/images/btn_icon_header_registration_sp-d2e320225864e4840f57e01ae22f9c2c.png";